import ResponsiveIcon from './ResponsiveIcon';

export default ResponsiveIcon;
